import React, { useEffect, useState } from "react"
import { RichText } from "prismic-reactjs"
import kebabCase from "lodash/kebabCase"

import Grid from "legacy/components/shared/Grid"
import { Maybe } from "types/Maybe"
import NavItem, { NavItemProps } from "./NavItem"
import { Element, Text } from "legacy/components/shared/base"
import { PrismicPageDataBodyJumpNavigation } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  data: Maybe<PrismicPageDataBodyJumpNavigation>
}

export type JumpNavigationProps = OwnProps

const JumpNavigation: React.FC<JumpNavigationProps> = ({
  data,
}): React.ReactElement | null => {
  const [navItems, setNavItems] = useState<NavItemProps[]>([])

  const primary = data?.primary
  if (!primary) {
    return null
  }

  const sectionHeaderLevel = primary?.section_header_level || ""
  const title = primary?.jump_navigation_title

  useEffect(() => {
    const headerDataArray: NavItemProps[] = []
    const headers: any = document.getElementsByTagName(sectionHeaderLevel)

    ;[...headers].forEach(header => {
      const text = header.innerText
      const headerSlug = kebabCase(text)

      if (!text) {
        return
      }

      header.id = `${headerSlug}`
      headerDataArray.push({
        slug: headerSlug,
        text,
      })
    })

    setNavItems(headerDataArray)
  }, [])

  return (
    <Element px={["40"]}>
      <Grid
        margin={["35px auto 50px", "85px auto 50px"]}
        maxWidth="contentWidth"
      >
        {title && (
          <Text
            as="h1"
            fontSize={["28", "text.header"]}
            lineHeight={["34px", "1.37"]}
            mb="30"
            mx="auto"
            variant="header"
          >
            {RichText.asText(title?.richText)}
          </Text>
        )}
        <Element
          as="nav"
          borderTop="2SolidNavy"
          display="flex"
          gridGap="20"
          justifyContent="space-between"
          lineHeight="180%"
          overflowX="auto"
          whiteSpace="nowrap"
        >
          {navItems.map((item, index) => {
            return <NavItem text={item.text} slug={item.slug} key={index} />
          })}
        </Element>
      </Grid>
    </Element>
  )
}

export default JumpNavigation
